import * as Sentry from "@sentry/react";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { useCurrentAuth } from "features/auth/auth.store";
import history from "infra/helpers/history";

export function logError(err: any) {
  const tenant = useCurrentTenant.getState().tenant;
  const user = useCurrentAuth.getState().auth;
  const location = history.location;

  Sentry.withScope((scope) => {
    scope.setExtra("tenant", tenant);
    scope.setExtra("online", window.navigator.onLine);
    scope.setExtra("connection", window.navigator.connection);
    scope.setExtra("location", location);
    scope.setExtra("user", {
      userId: user.id,
      userEmail: user.email,
      userPessoa: user.pessoaId,
    });
    scope.setExtra("error", err);

    Sentry.captureException(err);
  });
}
